
// © Microsoft Corporation. All rights reserved.

/**
 * Enum to describe screen width(column types)
 */
export enum ScreenWidth {
    OneColumn = "OneColumn",
    TwoColumn = "TwoColumn",
    ThreeColumn = "ThreeColumn",
    FourColumn = "FourColumn",
    FiveColumn = "FiveColumn",
    Any = "Any"
}